<div class="header-alerts" [@animatedList]="animationState" [style.top.px]="top">
  <div class="header-alert {{ item.type }}" *ngFor="let item of alerts$ | async">
    <div class="content">
      <div class="wrap">
        <div class="message" [innerHTML]="item.translate ? item.content : item.content"></div>
        <a *ngIf="item.closable" class="alert-close" (click)="close(item.id)">
          <svg class="close">
            <use [attr.xlink:href]="'/assets/images/svg_ico/icons.svg#ic_close'"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
</div>
